import { render, staticRenderFns } from "./ConsultationAdd.vue?vue&type=template&id=66b463a7&scoped=true"
import script from "./ConsultationAdd.vue?vue&type=script&lang=js"
export * from "./ConsultationAdd.vue?vue&type=script&lang=js"
import style0 from "./ConsultationAdd.vue?vue&type=style&index=0&id=66b463a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b463a7",
  null
  
)

export default component.exports